<template>
  <el-select
    v-bind="$attrs"
    v-model="data"
    filterable
    remote
    reserve-keyword
    clearable
    :remote-method="searchRemote"
    :loading="loading"
    @change="change"
  >
    <el-option v-for="item in options" :key="item.id" :label="item[selectOptions.nameFormat || 'name']" :value="item[selectOptions.valueFormat || 'id']"></el-option>
  </el-select>
</template>
<script>
import {getUserNameAutoList, getAdminAutoList, projectAutoSelect, getAreaCity} from '@/api/base';
export default{
  name: 'SingleAutoComplete',
  props: {
    model_id: [Number, String],
    model_name: String,
    /**
     * selectOptions: Object
     *  apiType: 当前联动下拉类型 【必填】
     *  dataStruct：返回数据结构类型 ''表示直接返回Array(默认), 'data'表示返回对象包含data的Array
     *  model_id_label: id请求的参数名称, 默认id
     *  model_name_label: name请求的参数名称，默认name
     *  per_page: 列表显示长度,默认20
     *  params: 其余接口请求的参数
     *  valueFormat：返回值的字段名
     *  nameFormat: 显示值的字段名
     */
    selectOptions: Object
  },
  data() {
    return {
      data: '',
      loading: false,
      options: []
    }
  },
  watch: {
    model_id() {
      if (!this.model_id) {
        this.data = '';
        this.options = [];
      }else if ((this.model_id && this.data !== this.model_id)) {
        this.search();
      }
    }
  },
  computed: {
    fetchApi () {
      const { apiType } = this.selectOptions;
      if (!apiType) {
        console.error('请选择联动类型！');
        return null;
      }
      switch (apiType) {
        case 'permissionCustome': // 权限内的客户搜索
          return getUserNameAutoList;
        case 'agent': // 所有经纪人联动搜索
          return getAdminAutoList;
        case 'houses': // 意向楼盘联动搜索
          return projectAutoSelect;
        case 'citys':
          return getAreaCity;
        default:
          return () => {}
      }
    }
  },
  created() {
    if (this.model_id || this.model_name) {
      this.search()
    }
  },
  methods: {
    search () {
      this.fetchList(this.joinParamter(), () => {
        if (this.model_id) {
          this.data = Number(this.model_id);
        } else if (this.model_name) {
          // 模糊匹配包含搜索条件的
          const list = this.options.filter(v => (v[this.selectOptions?.model_name_label ?? 'name']?.indexOf(this.model_name) ?? -1) >= 0);
          if (list?.length > 0) {
            this.data = list[0]?.[this.selectOptions?.valueFormat??'id'] ?? '';
          }
          this.change();
        }
      })
    },
    searchRemote (query) {
      this.fetchList(this.joinParamter(query), () => {

      })
    },
    joinParamter (query) {
      const condition = {
        limit: this.selectOptions?.per_page ?? 20,
        page: 1,
        status: this.selectOptions?.status ?? 0,
        ...this.selectOptions?.params ?? {}
      };
      if (this.model_id) {
        condition[this.selectOptions?.valueFormat ?? 'id'] = this.model_id;
      };
      if (this.model_name) {
        condition[this.selectOptions?.model_name_label ?? 'name'] = this.model_name
      };
      if (query) {
        condition[this.selectOptions?.model_name_label ?? 'name'] = query
      }
      // 如果两个都存在的情况下，清除id选项的搜索条件
      if (condition[this.selectOptions?.model_name_label ?? 'name']) {
        delete condition[this.selectOptions?.model_id_label ?? 'id'];
      }
      return condition;
    },
    async fetchList (paramters, succcallback) {
      this.loading = true;
      try {
        const res = await this.fetchApi?.(paramters);
        const { dataStruct = '' } = this.selectOptions;
        const list = (!dataStruct ? res : res[dataStruct]) ?? [];
        this.options = list;
        succcallback?.();
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
        this.options = [];
      } finally {
        this.loading = false;
      }
    },
    change () {
      console.log('model_id', this.data)
      this.$emit('update:model_id', this.data);
      // 返回整个对象
      const item = this.options.find(v => v[this.selectOptions?.valueFormat ?? 'id'] === this.data) || null;
      this.$emit('update:model', item)
    },
    clear () {
      this.data = '';
      this.$emit('update:model_id', '');
      this.options = [];
    }
  }
}
</script>
